import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminAddGroupIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M5.373 6.667h-2v-2H2.04v2h-2V8h2v2h1.333V8h2V6.667Zm6.667.666a1.992 1.992 0 0 0 1.993-2 1.992 1.992 0 0 0-2.6-1.906c.38.54.6 1.193.6 1.906 0 .714-.226 1.36-.6 1.907.187.06.394.093.607.093Zm-3.333 0a1.992 1.992 0 0 0 1.993-2 1.997 1.997 0 1 0-3.993 0c0 1.107.893 2 2 2Zm4.413 1.44c.553.487.92 1.107.92 1.894V12h2v-1.333c0-1.027-1.58-1.66-2.92-1.894Zm-4.413-.106c-1.334 0-4 .666-4 2V12h8v-1.333c0-1.334-2.667-2-4-2Z" />
  </Icon>
);

export default memo(AdminAddGroupIcon);
